'use strict';

const component = angular.module('dash.nav.left.annotations.item', ['ngSanitize']);

component.controller('AnnotationItemController', require('./AnnotationItemController'));
component.directive('annotationsItem', require('./AnnotationItemDirective'));


// WEBPACK FOOTER //
// ./src/app/dash/nav/navLeft/annotations/item/index.js